import { Button, Stack, Typography } from "@mui/material";
import Title from "../../ui/Title";
import { Card } from "../../ui/Card";
import CustomDataTable from "../../ui/CustomDataTable";
import { useEffect, useState } from "react";
import { getShipmentProfilesApi } from "./setupApi";
import { useModal } from "../../../hooks/useModal";
import { create } from "zustand";
import { StyledButton } from "../../ui/StyledButton";

interface syncState {
  sync: number;
  setSync: () => void;
}

export const useSync = create<syncState>((set) => ({
  sync: 0,
  setSync: () => set((state) => ({ sync: state.sync + 1 })),
}));

const shipmentColumn = [
  {
    field: "product_name",
    headerName: "Product Name",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: any }) => (
      <>
        <Typography>{params.row?.product_name}</Typography>
      </>
    ),
  },
  {
    field: "description",
    headerName: "Description",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "hsn_code",
    headerName: "HSN code",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "dimension",
    headerName: "Dimension/Weight",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: any }) => (
      <Stack>
        <Typography fontSize={"12px"}>
          {params.row?.length} X {params.row?.width} X {params.row?.height}
        </Typography>
        <Typography fontSize={"12px"}>
          Volumetric: {params.row?.weight}
        </Typography>
      </Stack>
    ),
  },

  {
    field: "order_channel",
    headerName: "Channel",
    minWidth: 160,
    flex: 1,
  },
];

export interface ShipmentProfilesType {
  id: number;
  ship_profile_id: string;
  order_channel: string;
  product_name: string;
  description: string;
  length: number;
  width: number;
  height: number;
  weight: number;
  hsn_code: string;
}

const ShipmentProfiles = () => {
  const [shipmentData, setShipmentData] = useState<ShipmentProfilesType[]>([]);

  const { sync } = useSync();

  useEffect(() => {
    getShipmentProfilesApi()
      .then((data) => {
        const finalData: ShipmentProfilesType[] = data?.data?.data;
        finalData?.map((el, index) => {
          el.id = index + 1;
        });
        setShipmentData(finalData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [sync]);

  const { onOpen } = useModal();

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        marginBottom={"40px"}
      >
        <Title title="All Shipment" />
        <StyledButton
          variant="contained"
          sx={{
            textTransform: "none",
          }}
          onClick={() => onOpen("profile")}
        >
          Add profiles
        </StyledButton>
      </Stack>
      <Card>
        <CustomDataTable
          wantExcel={false}
          total={shipmentData.length ?? 0}
          rows={shipmentData ?? []}
          columns={shipmentColumn}
        />
      </Card>
    </>
  );
};

export default ShipmentProfiles;
